var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"personal-area",attrs:{"href":_vm.classeUrl + 'teacher/#!/'+ _vm.langLetters +'/session/selectClass/?hideLogout=true',"target":"_blank"}},[_c('p',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.$t('PERSONAL_AREA'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }